import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { isMobile } from '../../utils/environment';
import SvgIcon from '../common/base/SvgIcon.vue';
import TuiDialog from '../common/base/Dialog';
import ArrowStrokeBackIcon from '../common/icons/ArrowStrokeBackIcon.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PanelContainer',
  props: {
    visible: { type: Boolean },
    title: null,
    editButtonText: { type: [Boolean, String] },
    width: null
  },
  emits: ['input', 'edit'],
  setup(__props: any, { emit }) {

const props = __props as {
  visible: boolean;
  title?: string;
  editButtonText?: boolean | string;
  width?: string;
};




const panelVisible = ref(false);
const closePanel = () => {
  emit('input', false);
};
watch(
  () => props.visible,
  val => {
    panelVisible.value = val;
  },
  {
    immediate: true,
  }
);

watch(
  panelVisible,
  val => {
    emit('input', val);
  },
  { immediate: true }
);

const handleEdit = () => emit('edit');

return { __sfc: true,emit, props, panelVisible, closePanel, handleEdit, isMobile, SvgIcon, TuiDialog, ArrowStrokeBackIcon }
}

})